import { apiReq } from 'src/services/client';
import { baseUrl } from 'src/Tenants';

export const setupMFA = async (userId: string, method: 'email' | 'totp') => {
  const response = await apiReq(
    baseUrl + 'api/usermanagement/2fa/setup',
    'POST',
    true,
    { userId, method: method === 'email' ? 2 : 1 },
    false
  );
  return response;
};

export const completeSetupMFA = async (
  userId: string,
  method: 'email' | 'totp',
  code: string
) => {
  const response = await apiReq(
    baseUrl + 'api/usermanagement/2fa/complete-setup',
    'POST',
    true,
    { userId, method: method === 'email' ? 2 : 1, code },
    false
  );
  return response;
};
